/* eslint-disable */
// AUTO-GENERATED by backend/scripts/match_speaker_backdrops.py
// Run that script again to refresh.
// Maps speaker.name → studio backdrop hex chosen by
// face-luminance-aware matching against the 225-color palette
// in `speakerPalette.js`.

export const SPEAKER_BACKDROP_MAP = {
  " Akiva Paris's All Star Vaadim picks": "#0f1729",
  "Akiva Paris": "#422348",
  "Akiva Paris's recordings from Queens 2025-2026": "#a2513f",
  "Are You A Lamdan?": "#b76a52",
  "Brooklyn Tiferes Yisrael": "#6d3418",
  "CCJ": "#7a1e2b",
  "Chofetz Chaim": "#133f4e",
  "Dr. Allan Jacob": "#351f3c",
  "Dr. Allen Jacob": "#351f3c",
  "From D Frydman R Muskat vaadim": "#253a68",
  "HaRav Akiva Grunblatt": "#e8dfc9",
  "HaRav Dovid Harris": "#a55943",
  "HaRav Henach Leibowitz Z'TL": "#f4efe4",
  "HaRav Henach Leibowitz Zt'l": "#f4efe4",
  "HaRav Henach Leibowitz Ztzl": "#f4efe4",
  "HaRav Shaul Opoczynski": "#ede4d1",
  "Halacha": "#26173a",
  "Harav Akiva Grunblatt": "#e8dfc9",
  "Harav Dovid Harris": "#a55943",
  "Harav Shaul Opoczynski": "#ede4d1",
  "Hashkafa": "#334c35",
  "Hespedim": "#152547",
  "MTI GUEST SPEAKERS": "#23293d",
  "MTI Guest Speakers.jfif": "#23293d",
  "Meetings of the Sisterhood": "#3a1a3e",
  "Miami Guest Speakers (YTCTE)": "#1e335a",
  "Miami Guest Speakers Miami recordings ytcte": "#1e335a",
  "Miami Recordings": "#9e4b64",
  "Miscellaneous": "#1b3521",
  "Q & A's": "#0d3542",
  "Queens Vaadim 2005": "#215061",
  "Queens Vaadim 2005-2025": "#a2513f",
  "R' Abba Goldman": "#294028",
  "R' Abbi Ephraim Palgon": "#7a5e3a",
  "R' Aharon Kamin": "#20293a",
  "R' Ahron Kamin. jpg": "#20293a",
  "R' Ahron Winter": "#b76a52",
  "R' Ahron Winter zt\"l": "#b76a52",
  "R' Andom": "#215061",
  "R' Aryeh Goldman": "#301c30",
  "R' Aryeh Rodin": "#5f1b25",
  "R' Aryeh Wender": "#af8628",
  "R' Aryeh Winter": "#b0862a",
  "R' Aryeh Zev Ginsberg": "#1f3325",
  "R' Aryeh Zev Ginzberg": "#1f3325",
  "R' Asa Minkowich": "#f4efe4",
  "R' Avi Fertig": "#ede4d1",
  "R' Avi Goldman": "#93744e",
  "R' Avi Mandel": "#a75742",
  "R' Avi Rhodes": "#2b3d62",
  "R' Avraham Kanarek": "#172d54",
  "R' Avrahom Semmel": "#6d4f2a",
  "R' Avrahom Yachnes": "#3b1f42",
  "R' Avrohom Kanerak zt\"l": "#172d54",
  "R' Avrohom Semmel": "#b56a80",
  "R' Avrohom Stuhlberger": "#331d38",
  "R' Avrohom Stulberger": "#331d38",
  "R' Azriel Lowenthal": "#442850",
  "R' Baruch Wasser": "#4a3220",
  "R' Bc": "#a75b48",
  "R' Bentzion Chait": "#c19a37",
  "R' Bentzion Shafier": "#6b1f2a",
  "R' Benzion Chait": "#c67665",
  "R' Benzion Shafier": "#4a3220",
  "R' Binyomin Luban": "#b76451",
  "R' Boruch Feinstein": "#c0a03d",
  "R' Ccj": "#7a1e2b",
  "R' Chaim Kazan": "#f5edd5",
  "R' Chaim Wagner": "#133f4e",
  "R' Chananya Kramer": "#262c3e",
  "R' Daniel Glatstein": "#a75742",
  "R' Daniel Glattstein": "#a75742",
  "R' Daniel Ringelheim": "#f5edd5",
  "R' Dc": "#b76451",
  "R' Doniel Spector": "#a58562",
  "R' Dovid Chait": "#b6902d",
  "R' Dovid Goldman": "#1f3325",
  "R' Dovid Opoczynski": "#22283a",
  "R' Dovid Orlafsky": "#6c2732",
  "R' Dovid Orlofsky": "#163445",
  "R' Dovid Sharfman": "#8d4257",
  "R' Dovid Turk": "#5f321a",
  "R' Dovid Weiner": "#f4efe4",
  "R' Ef": "#0e2f3b",
  "R' Eli Riesel": "#552024",
  "R' Elisha Feinberg": "#a8842b",
  "R' Eliyahu Kaufman": "#5f321a",
  "R' Ephraim Friedman": "#b0862a",
  "R' Ephraim Rosenholtz": "#152547",
  "R' Ephraim Zachai": "#75601c",
  "R' Euvain Kamin": "#26362a",
  "R' Gedalya Glatt": "#2b3d62",
  "R' Halacha": "#26173a",
  "R' Hashkafa": "#334c35",
  "R' Hayim Schwartz": "#334c35",
  "R' Herschel Welcher": "#34213a",
  "R' Hespedim": "#152547",
  "R' IIlan Feder": "#957a58",
  "R' Ilan Feder on right R' Yisroel Kramer on left": "#957a58",
  "R' Joseph Grunblatt": "#2c3a5c",
  "R' Joswf Grunblatt": "#2c3a5c",
  "R' Kalman Bauman": "#1c2c53",
  "R' Kalman Baumann 1024x": "#ede4d1",
  "R' Meir Glazer": "#152547",
  "R' Menachem Diamond": "#2c1f42",
  "R' Miscellaneous": "#1b3521",
  "R' Mordechai Palgon": "#a4842d",
  "R' Moshe Chait": "#193a45",
  "R' Moshe Chait zt\"l": "#c67665",
  "R' Moshe Chait zt\u201dl": "#193a45",
  "R' Moshe Dov Wasser": "#16303a",
  "R' Moshe Gruenstein": "#5a3a1a",
  "R' Moshe Kamin": "#0f394d",
  "R' Moshe Kleinerman": "#1a1f2b",
  "R' Moshe Turk": "#e8dfc9",
  "R' Mt": "#6a4f30",
  "R' Nachshon Aronovitch": "#7a1e2b",
  "R' Nachum Meth": "#1f3325",
  "R' Nachum Zlotnick": "#65212a",
  "R' Naftali Kalter": "#133f4e",
  "R' Naftali Zions": "#1e2634",
  "R' Nerya Aminov": "#2f4034",
  "R' Noach Light": "#23283b",
  "R' Noach light": "#23283b",
  "R' Noam Abromchik": "#a0814a",
  "R' Noam Grossman": "#6a4f30",
  "R' Sa": "#153525",
  "R' Sender Strassfeld": "#6d3418",
  "R' Shalom Meltzer": "#f0e9d7",
  "R' Shalom Muskat": "#6d5230",
  "R' Shaps": "#294028",
  "R' Shimon Max": "#6a3a1a",
  "R' Shimon Zhenwirth": "#eee8d9",
  "R' Shlomo Pacht": "#c26e57",
  "R' Shlomo Yonoson Harris": "#16303a",
  "R' Shlomo Zalman Koss": "#253a68",
  "R' Shmuel Niman": "#a75742",
  "R' Shmuel Wasser": "#b56a80",
  "R' Shmuessim": "#4a1720",
  "R' Sholom Richmond": "#9d503d",
  "R' Sisterhood": "#3a1a3e",
  "R' Stulberger": "#331d38",
  "R' Trop": "#c07a92",
  "R' Uvain Becker E X": "#96522c",
  "R' Wachsman": "#c47762",
  "R' Yaakov Dreyfus": "#f5edd5",
  "R' Yaakov Fried History Series": "#122d3e",
  "R' Yaakov Kier": "#8d4257",
  "R' Yaakov Moskowitz": "#26362a",
  "R' Yaakov Niman": "#152547",
  "R' Yaakov Trop": "#c07a92",
  "R' Ydsaxon": "#7d6720",
  "R' Yehoshua Schloss": "#b06556",
  "R' Yehuda Israel 300x": "#0e2f3b",
  "R' Yehudah Bergida": "#0f394d",
  "R' Yehudah Jacobson": "#3a5138",
  "R' Yehudah Shmidman": "#3a4a70",
  "R' Yisroel Niman": "#152547",
  "R' Yissocher Weiner": "#734020",
  "R' Yitzchak Schwartz": "#832836",
  "R' Yitzchok Schlissel": "#2f4237",
  "R' Yosef Singer": "#8f7025",
  "R' Zisha Shaps": "#294028",
  "R' Zvi Turk": "#a75b48",
  "R' chaim shmuel blinder 300x": "#6c2732",
  "R'Yaakov Nissan": "#152547",
  "RY ztl": "#0f394d",
  "Rabbi Abba Goldman": "#294028",
  "Rabbi Aharon Kamin": "#26362a",
  "Rabbi Aryeh Goldman": "#1e335a",
  "Rabbi Aryeh Rodin": "#5f1b25",
  "Rabbi Aryeh Wender": "#af8628",
  "Rabbi Aryeh Winter": "#b0862a",
  "Rabbi Aryeh Zev Ginzberg": "#1f3325",
  "Rabbi Asa Minkowitch": "#193a45",
  "Rabbi Avi Goldman": "#93744e",
  "Rabbi Avi Mandel": "#a75742",
  "Rabbi Avi Rhodes": "#2b3d62",
  "Rabbi Avrohom G Yachnes": "#26173a",
  "Rabbi Avrohom M. Mendelson": "#a25a2d",
  "Rabbi Avrohom Semmel": "#6d4f2a",
  "Rabbi Avrohom Stulberger": "#331d38",
  "Rabbi Bentzion Chait": "#c67665",
  "Rabbi Bentzion Shafier": "#4a3220",
  "Rabbi Binyomin Luban": "#7d2635",
  "Rabbi Boruch Feinstein": "#c0a03d",
  "Rabbi Chaim Glazer": "#2e1f36",
  "Rabbi Chaim Shmuel Blinder": "#6c2732",
  "Rabbi Daniel Glattstein": "#a75742",
  "Rabbi Doniel Spector": "#a58562",
  "Rabbi Dovid Chait": "#b6902d",
  "Rabbi Dovid Goldman": "#98805c",
  "Rabbi Dovid Orlafsky": "#163445",
  "Rabbi Dovid Sharfman": "#8d4257",
  "Rabbi Dovid Turk": "#5f321a",
  "Rabbi Eli Riesel": "#552024",
  "Rabbi Elisha Feinberg": "#a8842b",
  "Rabbi Eliyahu Kaufman": "#5f321a",
  "Rabbi Ephraim Friedman": "#b0862a",
  "Rabbi Ephraim Rosenholtz": "#152547",
  "Rabbi Ephraim Rozenholtz": "#152547",
  "Rabbi Ephraim Zachai Mussar": "#75601c",
  "Rabbi Gedalya Glatt": "#5a2b1d",
  "Rabbi Herschel Welcher": "#442850",
  "Rabbi Joseph Grunblatt": "#a75b48",
  "Rabbi Kalman Bauman": "#ede4d1",
  "Rabbi Meir Glazer": "#152547",
  "Rabbi Menachem Diamond": "#2c1f42",
  "Rabbi Mordechai Palgon": "#182b1e",
  "Rabbi Moshe Dov Wasser": "#16303a",
  "Rabbi Moshe Gruenstein": "#5a3a1a",
  "Rabbi Moshe Kamin": "#3b2340",
  "Rabbi Moshe Turk": "#e8dfc9",
  "Rabbi Nachshon Aronovich": "#9e4b64",
  "Rabbi Nachshon Aronovitch": "#152547",
  "Rabbi Nachum Zlotnick": "#65212a",
  "Rabbi Naftali Zions": "#1e2634",
  "Rabbi Nerya Aminov": "#2f4034",
  "Rabbi Noach Light": "#23283b",
  "Rabbi Noam Abromchik": "#a7885c",
  "Rabbi Ruvain Becker": "#96522c",
  "Rabbi Sender Strassfeld": "#6d3418",
  "Rabbi Shalom Meltzer": "#243a2c",
  "Rabbi Shalom Muskat": "#6d5230",
  "Rabbi Shaps": "#294028",
  "Rabbi Shlomo Yonasan Harris": "#16303a",
  "Rabbi Shmuel Niman Ztzl": "#a75742",
  "Rabbi Shmuel Wasser": "#b56a80",
  "Rabbi Sholom Richmond": "#9d503d",
  "Rabbi Stulberger": "#331d38",
  "Rabbi Trop": "#c07a92",
  "Rabbi Wachsman": "#c47762",
  "Rabbi Yaacov Dreyfus": "#f5edd5",
  "Rabbi Yaacov Kier": "#8d4257",
  "Rabbi Yaacov Moskowitz": "#a55c76",
  "Rabbi Yaacov Niman": "#152547",
  "Rabbi Yehoshua Schloss": "#b06556",
  "Rabbi Yehuda Shmidman": "#3a4a70",
  "Rabbi Yehudah Bergida": "#f7f5f0",
  "Rabbi Yehudah Jacobson": "#3a5138",
  "Rabbi Yissocher Weiner": "#f4efe4",
  "Rabbi Yitzchak Schwartz": "#832836",
  "Rabbi Yitzchok Schlissel": "#2f4237",
  "Rabbi Yosef Singer": "#8f7025",
  "Rabbi Zvi Turk": "#5f321a",
  "Random Shiurim": "#215061",
  "Random Vaadim": "#215061",
  "Rebbe Alter Yachnes Zt'l": "#161d2c",
  "Rebbe Alter Yachnes zt\"l": "#3b1f42",
  "R\u2019 Aharon Winter": "#b76a52",
  "R\u2019 Aryeh Goldman": "#1e335a",
  "R\u2019 Avi Fertig": "#ede4d1",
  "R\u2019 Avrahom Yachnes": "#3b1f42",
  "R\u2019 Boruch Davidowitz": "#1d2530",
  "R\u2019 Chaim Glazer": "#2e1f36",
  "R\u2019 Chaim Juni": "#a55943",
  "R\u2019 Doniel Spector": "#a58562",
  "R\u2019 Dovid Goldman": "#98805c",
  "R\u2019 Dovid Kitanik": "#163c4a",
  "R\u2019 Eliyahu Davidowitz": "#2f4237",
  "R\u2019 Ephraim Rosenholtz": "#152547",
  "R\u2019 Gedalya Glatt": "#5a2b1d",
  "R\u2019 Kalman Baumen": "#1c2c53",
  "R\u2019 Menachem Diamond": "#2c1f42",
  "R\u2019 Moshe Gruenstein": "#5a3a1a",
  "R\u2019 Moshe Kamin": "#3b2340",
  "R\u2019 Moshe Turk": "#e8dfc9",
  "R\u2019 Nachum Meth": "#1f3325",
  "R\u2019 Naftali Zions": "#1e2634",
  "R\u2019 Nerya Aminov": "#2f4034",
  "R\u2019 Noach Abromchik": "#a0814a",
  "R\u2019 Shmuel Wasser": "#b56a80",
  "R\u2019 Tuvya Aronovitch": "#152547",
  "R\u2019 Yaakov Fried": "#122d3e",
  "R\u2019 Yaakov Moskowitz": "#a55c76",
  "R\u2019 Yaakov Weisman": "#5c1f27",
  "R\u2019 Yehoshua Fromowitz": "#824417",
  "R\u2019 Yisrael Davidowitz": "#a8842b",
  "R\u2019 Ztvi Turk": "#5f321a",
  "Shmuessim": "#4a1720",
  "Summer in Eretz Yisroel": "#957a58",
  "Tifferes Yisroel Guest Speakers": "#7d5d38",
  "Vaadim": "#253a68",
  "paris": "#422348"
};
